import baseDidCreate from '../backboneUser/didCreate_identity_backboneUser_success';
import { constants } from 'lib_ui-services';

export default {
    ...baseDidCreate,
    relation: 'user',
    useCaseIds: [constants.useCaseIds.FREIGHT_RUNNER]
};
